module.exports = __webpack_public_path__ + "static/media/helicopter.5ab6b41b.svg";